export const normalizeBundleOption = (value) =>
  String(value ?? "")
    .trim()
    .toLowerCase()
    .replace(/[×]/g, "x")
    .replace(/\s+/g, "")
    .replace(/,/g, ".");

export const bundleDimensionToken = (value) => {
  const match = normalizeBundleOption(value).match(/\d+(?:\.\d+)?x\d+(?:\.\d+)?/);
  return match?.[0] ?? "";
};

const COLOR_OPTION_NAMES = new Set(["farbe", "farbe (muster)", "muster", "design mutterpasshülle", "color"]);

export const bundleVariantSubtitle = (optionNames, optionValues) => {
  const names = (optionNames ?? []).map((name) => String(name ?? "").trim().toLowerCase());
  const values = optionValues ?? [];
  const varianteIndex = names.indexOf("variante");
  const variantePart = varianteIndex >= 0 ? String(values[varianteIndex] ?? "").trim() : "";
  const colorIndex = names.findIndex((name) => COLOR_OPTION_NAMES.has(name));
  const colorPart = colorIndex >= 0 ? String(values[colorIndex] ?? "").trim() : "";

  const label = variantePart && colorPart ? `${variantePart} – ${colorPart}` : colorPart || variantePart;
  return label.replace(/\S+/g, (word) => {
    const lower = word.toLowerCase();
    return lower.charAt(0).toUpperCase() + lower.slice(1);
  });
};

export const bundleOptionMatches = (candidate, wanted) => {
  const normalizedCandidate = normalizeBundleOption(candidate);
  const normalizedWanted = normalizeBundleOption(wanted);
  if (normalizedCandidate === normalizedWanted) return true;

  const wantedDimensions = bundleDimensionToken(wanted);
  return wantedDimensions !== "" && bundleDimensionToken(candidate) === wantedDimensions;
};

export const calculateBundleTotals = (items) =>
  items.reduce(
    (totals, item) => {
      const price = Math.max(0, Math.round(item.price));
      const discountPercent = Math.min(100, Math.max(0, item.discountPercent));
      const setPrice = Math.round((price * (100 - discountPercent)) / 100);

      return {
        individual: totals.individual + price,
        set: totals.set + setPrice,
        savings: totals.savings + price - setPrice,
      };
    },
    { individual: 0, set: 0, savings: 0 },
  );

export const bundleLineAttribute = (discountPercent) =>
  String(Math.min(100, Math.max(0, Math.round(Number(discountPercent) || 0))));

export const isBundleOptionAvailable = (variants, selections, optionIndex, value) =>
  variants.some(
    (variant) =>
      variant.available &&
      variant.options[optionIndex] === value &&
      selections.every((selected, index) => index === optionIndex || variant.options[index] === selected),
  );

export const calculateAllocatedBundleSavings = (items, discountTitle = "Set-Vorteil") =>
  items.reduce((cartTotal, item) => {
    if (!item.properties?._ek_bundle) return cartTotal;
    return cartTotal + (item.discounts || []).reduce((lineTotal, discount) => lineTotal + (discount.title === discountTitle ? discount.amount : 0), 0);
  }, 0);
